<div class="frame-with-title-container">
  <div class="frame-with-title-heading">
    <span translate>{{title}}</span>
  </div>
  <div class="frame-with-title-contents">
    <ng-content></ng-content>
  </div>
</div>